// Espelha app/services/modelo_uniforme_service.resolver_preco() do backend — único
// lugar do frontend que deve ler preço de modelo. Nunca ler modelo.preco_unitario
// direto fora daqui: para tipo_preco="por_tamanho" ele vem sempre null.
export function resolverPreco(modelo, idTamanhoUniforme) {
  if (!modelo) return 0;
  if (modelo.tipo_preco === 'por_tamanho') {
    const t = (modelo.tamanhos || []).find(x => x.id_tamanho_uniforme === idTamanhoUniforme);
    return t?.preco_unitario != null ? Number(t.preco_unitario) : 0;
  }
  return Number(modelo.preco_unitario) || 0;
}

// Preço "de vitrine" quando ainda não há tamanho selecionado (grid do catálogo).
export function precoVitrine(modelo) {
  if (modelo?.tipo_preco !== 'por_tamanho') {
    return { valor: Number(modelo?.preco_unitario) || 0, aPartirDe: false };
  }
  const precos = (modelo.tamanhos || [])
    .map(t => t.preco_unitario)
    .filter(p => p != null)
    .map(Number);
  return { valor: precos.length ? Math.min(...precos) : 0, aPartirDe: true };
}
